export default "__VITE_ASSET__c2504e81__"